import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalShopSettings from "@faire/web-api--source/routes/brand-portal/my-shop/settings";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const InternationalOrderSettingsIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="You can manage your shop's visibility to other countries in your <LinkFormatting>Shop settings</LinkFormatting>. To restrict selling to a country, simply deselect the country from the list of countries. You can also set country-specific order minimums for first orders and reorders."
          values={{
            LinkFormatting: ShopSettingsLinkFormatting,
          }}
          description={{
            text: "Introduction to managing international orders",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Navigate to the <BoldFormatting>Settings</BoldFormatting> page."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "First step to manage international orders",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Select <LinkFormatting>Shop settings</LinkFormatting> and scroll down to <BoldFormatting>International orders</BoldFormatting>."
              values={{
                LinkFormatting: ShopSettingsLinkFormatting,
                BoldFormatting,
              }}
              description={{
                text: "Second step to manage international orders",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="To restrict selling to a country, deselect that country’s checkbox. To allow selling, select that country’s checkbox."
              description={{
                text: "Third step to manage international orders",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Save</BoldFormatting> any changes."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Fourth step to manage international orders",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
    </Column>
  );
};

const ShopSettingsLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalShopSettings()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
